import React from 'react';

const xIcon = props => (
  <svg viewBox="0 0 12 12" {...props}>
    <g stroke="none" fillRule="evenodd">
      <path d="M6,4.58578644 L1.75735931,0.343145751 L0.343145751,1.75735931 L4.58578644,6 L0.343145751,10.2426407 L1.75735931,11.6568542 L6,7.41421356 L10.2426407,11.6568542 L11.6568542,10.2426407 L7.41421356,6 L11.6568542,1.75735931 L10.2426407,0.343145751 L6,4.58578644 Z"/>
    </g>
  </svg>
);

export default xIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/x-icon.js